import { BodyText, Caption, Flex, LocationIcon } from '@kvdbil/components';
import React from 'react';
import { useIsDevice } from '~/App/shared/hooks/useIsDevice';

export const Location = ({
  locationToDisplay
}: {
  locationToDisplay: string;
}) => {
  const { isMobile } = useIsDevice();

  return (
    <Flex justify={'flex-start'} gap={'0.25rem'}>
      <LocationIcon height={'0.875rem'} />
      {isMobile ? (
        <BodyText>{locationToDisplay}</BodyText>
      ) : (
        <Caption>{locationToDisplay}</Caption>
      )}
    </Flex>
  );
};
